import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  root: { display: 'flex' },

  appBar: { zIndex: theme.zIndex.drawer + 1 },

  toolbar: { backgroundColor: '#262632',
  
},

  banner: { color: '#d6a65d', fontSize: 30, letterSpacing: 10, fontWeight: 600 },

  icon: {
    color: '#878787',
    '&.active': { color: '#dddddd' }
  },

  badge: { backgroundColor: '#d6a65d', color: '#5a4523' },

  grow: { flexGrow: 1 },

  avatar: {
    color: '#fff',
    cursor: 'pointer',
    backgroundColor: '#22313f',
    width: 45,
    height: 45,
    margin: 5,
    border: '2px solid #d6a65d'
  },

  subscriptionTypography: { color: '#878787' },
  subscriptionTypographySpan: { color: '#fff', marginLeft: 10 },

  upgradeButton: {
    border: '1px solid #d6a65d',
    color: '#d6a65d',
    borderRadius: 20,
    marginLeft: 15,
    padding: '8px 20px',
    marginRight: 20
  },
  menuButton:{
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]:{
      display:'none'
    },
    color:'white'
  }
}));
